<template>
  <div class="bg-footer mt-4">
    <div class="container">
      <div class="row">
        <div
          class="d-none col-lg-3 d-lg-flex justify-content-center img-container"
        >
          <img
            src="../../assets/img/forum/icono-footer-1.svg"
            class="imagen-footer"
            alt=""
          />
        </div>
        <div
          class="
            col-lg-6
            d-flex
            flex-column
            justify-content-center
            align-items-center
            containter-boton
          "
        >
          <span class="mb-3"
            >¿Tu centro educativo aún no tiene Progrentis?</span
          >
          <a href="https://www.progrentis.com/" class="btn btn-primary mt-2">Descúbrelo</a>
        </div>
        <div
          class="d-none col-lg-3 d-lg-flex justify-content-center img-container"
        >
          <img
            src="../../assets/img/forum/icono-footer-2.svg"
            class="imagen-footer"
            alt=""
          />
        </div>
        <div class="col-md-12 text-center">
          <a class="mt-2" @click="showModal = true">Soporte técnico</a>
        </div>
      </div>
    </div>
    <b-modal
      v-model="showModal"
      centered
      hide-footer
      hide-header-close
      hide-header
      size="lg"
    >
      <b-card-text class="py-3">
        <h4 class="text-center titulo-modal font-weight-bold">
          Soporte técnico
        </h4>
        <br />
        <div class="contact-from-wrapper container">
          <div class="contact-page-form">
            <div class="contact-input">
              <div class="contact-inner">
                <input
                  name="con_name"
                  v-model="form.con_name"
                  type="text"
                  placeholder="Nombre completo *"
                />
              </div>
              <div class="contact-inner">
                <input
                  name="con_email"
                  type="email"
                  v-model="form.con_email"
                  placeholder="Correo *"
                />
              </div>
            </div>
            <div class="contact-inner">
              <input
                name="con_subject"
                type="text"
                v-model="form.con_subject"
                placeholder="Asunto *"
              />
            </div>
            <div class="contact-inner contact-message">
              <textarea
                name="con_message"
                placeholder="Mensaje *"
                v-model="form.con_message"
              ></textarea>
            </div>
            <div class="contact-submit-btn text-center">
              <button
                class="ht-btn-progrentis btn-soporte ht-btn-md"
                @click="validarForm()"
              >
                Enviar comentarios
              </button>
              <p class="form-messege"></p>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import { BModal } from "bootstrap-vue";
import gql from "graphql-tag";
import { load } from "recaptcha-v3";
export default {
  name: "SimpleFooterForum",
  data() {
    return {
      showModal: false,
      tokenRecaptach: "",
      form: {
        con_name: "",
        con_email: "",
        con_subject: "",
        con_message: "",
      },
    };
  },
  components: {
    BModal,
  },
  mounted() {
    this.getTokenRecapcha();
  },
  methods: {
    async getTokenRecapcha() {
      const recaptcha = await load("6LcB-vIaAAAAAHPKTW8Bis4_GSeH88cU5i-UGVzN", {
        useRecaptchaNet: true,
        autoHideBadge: true,
      });
      const token = await recaptcha.execute("login");
      this.tokenRecaptach = token;
    },
    validarForm() {
      // eslint-disable-next-line no-constant-condition
      if (
        this.form.con_name &&
        this.form.con_email &&
        this.form.con_subject &&
        this.form.con_message
      ) {
        this.enviarCorreo();
      } else {
        this.$swal({
          position: "bottom-end",
          icon: "error",
          title: "¡Error!",
          text: "Todos los campos son obligatorios",
          showConfirmButton: false,
          timer: 5000,
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },
    enviarCorreo() {
      if (this.tokenRecaptach != "") {
        this.$apollo
          .mutate({
            mutation: gql`
              mutation ($input: MailInput) {
                enviarCorreo(input: $input) {
                  correo
                  nombre
                }
              }
            `,
            variables: {
              input: {
                nombre: this.form.con_name,
                correo: this.form.con_email,
                asunto: this.form.con_subject,
                mensaje: this.form.con_message,
                tipo: "Consulta",
              },
            },
          })
          .then(() => {
            // eslint-disable-next-line no-console
            this.$swal({
              position: "center",
              icon: "success",
              title: "Enviado con éxito",
              text: "Pronto estaremos en contacto contigo.",
              showConfirmButton: false,
              timer: 5000,
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
            this.showModal = false;
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.log(error);
          });
      } else {
        this.$swal({
              position: "bottom-end",
              icon: "error",
              title: "¡Error!",
              text: "Reguridad reCAPTCHA no aprobada.",
              showConfirmButton: false,
              timer: 5000,
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-soporte {
  border-radius: 50px;
}
.titulo-modal {
  color: #000000;
}
.bg-footer {
  background: #eff3fb;
  height: 280px;

  .img-container {
    position: relative;
  }

  .imagen-footer {
    position: absolute;
    top: -130px;
    height: 300px;
  }

  .containter-boton {
    height: 200px;

    span {
      font-family: "Mulish";
      font-style: normal;
      font-weight: 800;
      font-size: 20px;
      line-height: 25px;
      text-align: center;
      color: #000000;
    }
  }
}
</style>